import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

interface ScrollOptions {
  behavior?: 'auto' | 'smooth' | 'instant'
  block?: 'start' | 'center' | 'end' | 'nearest'
  inline?: 'start' | 'center' | 'end' | 'nearest'
}

const useHashFragment = (options?: ScrollOptions): void => {
  const { pathname, hash, key } = useLocation()

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      return
    }

    const timeoutId = setTimeout(() => {
      const id = hash.replace('#', '')
      const element = document.getElementById(id)

      if (element) {
        element.scrollIntoView({
          behavior: options?.behavior || 'smooth',
          block: options?.block || 'start',
          inline: options?.inline || 'nearest',
        })
      } else {
        console.warn(`Element with id "${id}" not found`)
      }
    }, 100)

    return () => clearTimeout(timeoutId)
  }, [pathname, hash, key, options])
}

export default useHashFragment